import { render, staticRenderFns } from "./animatedToman.vue?vue&type=template&id=01f1fcb3&"
import script from "./animatedToman.vue?vue&type=script&lang=js&"
export * from "./animatedToman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports